import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import { merge, of } from "rxjs";

import { EXPORT_MONITORING_QUEUE } from "../types";
import {
  exportMonitoringQueueFulfilled,
  exportMonitoringQueuePending,
  exportMonitoringQueueRejected,
} from "../actions";
import { sendApiRequest, notifyError, notifyWarning } from "../../../actions";

import generateError from "../../../utilities/generateError";

const createPayload = (payload) => ({
  method: "post",
  url: "monitoringqueueentry/export",
  onSuccess: [
    exportMonitoringQueueRejected,
    (response) =>
      !response.headers["content-disposition"]
        ? notifyWarning(
            "Your query is taking more than 10 seconds, it will be converted to Mass Action, check it in Reports > Export"
          )
        : response.data.length === 0
        ? notifyWarning(EXPORT_MONITORING_QUEUE.NOT_FOUND)
        : exportMonitoringQueueFulfilled(response),
  ],
  onError: [
    exportMonitoringQueueRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "pdfApi",
};

const exportMonitoringQueueEpic$ = (action$) =>
  action$.pipe(
    ofType(EXPORT_MONITORING_QUEUE.DEFAULT),
    mergeMap(({ payload }) =>
      merge(
        of(exportMonitoringQueuePending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default exportMonitoringQueueEpic$;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/epics/exportMonitoringQueueEpic.js